import React, { useState } from 'react';
import { login } from '../../utils/api';

function AdminLogin({ onLogin }) {
    const [pw, setPw] = useState('');
    const [err, setErr] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErr('');
        try {
            await login(pw);
            onLogin();
        } catch (e) {
            setErr(e.message || '로그인 실패');
            setPw('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-wrap">
            <div className="admin-login-box">
                <h1>Portfolio Admin</h1>
                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        placeholder="비밀번호"
                        value={pw}
                        onChange={e => setPw(e.target.value)}
                        autoFocus
                        disabled={loading}
                    />
                    {err && <p className="admin-login-err">{err}</p>}
                    <button type="submit" disabled={loading}>
                        {loading ? '확인 중...' : '로그인'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AdminLogin;
